/**
 * Load ALL media across every event (for the global timeline & map).
 *
 * Lists the entire thumb_uploads/ prefix once and enriches with EXIF sidecars.
 * Capped for safety; if the library grows very large this should move to a
 * server-side index, but for a personal/event gallery a full listing is fine.
 */
import { useQuery } from '@tanstack/react-query';
import { listAllFiles } from '../lib/apiClient.ts';
import { S3_CONFIG } from '../config/awsConfig.ts';
import { buildMediaItems } from '../lib/mediaItem.ts';
import type { MediaItem } from '../lib/types.ts';

const THUMB_PREFIX = `${S3_CONFIG.THUMBNAIL_PREFIX}/`;

export function useAllMedia() {
  return useQuery({
    queryKey: ['all-media'],
    staleTime: 60_000,
    queryFn: async ({ signal }): Promise<MediaItem[]> => {
      const files = await listAllFiles({ prefix: THUMB_PREFIX, maxKeys: 1000, signal });
      return buildMediaItems(files);
    },
  });
}
